import usePageSize from './pagesize.js'
import useModules from './modules.js'
import usefold from './fold.js'

export default function useStore() {
	return {
		pagesize: usePageSize(),
		modules: useModules(),
		fold: usefold()
	}
}

